import { trackAnalyticsEvent } from '@pm/analytics';
import { StreamedSpanJSON } from '@sentry/core';

type SpanAttributes = StreamedSpanJSON['attributes'];

const MEASUREMENT_ATTRIBUTES = {
  fcp: 'browser.web_vital.fcp.value',
  fp: 'browser.web_vital.fp.value',
  ttfb: 'browser.web_vital.ttfb.value',
  'ttfb.requestTime': 'browser.web_vital.ttfb.request_time',
  connection_rtt: 'network.connection.rtt',
} as const;

const DATA_ATTRIBUTES = {
  'sentry.op': 'sentry.op',
  'sentry.idle_span_finish_reason': 'sentry.idle_span_finish_reason',
  effectiveConnectionType: 'network.connection.effective_type',
  connectionType: 'network.connection.type',
} as const;

const stringAttribute = (attributes: SpanAttributes, name: string) => {
  const value = attributes[name];
  return typeof value === 'string' ? value : undefined;
};

const millisecondMeasurements = (attributes: SpanAttributes) => {
  const measurements: Record<string, { value: number; unit: string }> = {};
  Object.entries(MEASUREMENT_ATTRIBUTES).forEach(([measurement, attribute]) => {
    const value = attributes[attribute];
    if (typeof value === 'number') {
      measurements[measurement] = { value, unit: 'millisecond' };
    }
  });
  return measurements;
};

const dataWithPreStreamingNames = (attributes: SpanAttributes) => {
  const data: SpanAttributes = {};
  Object.entries(DATA_ATTRIBUTES).forEach(([preStreamingName, attribute]) => {
    const value = attributes[attribute];
    if (value !== undefined) {
      data[preStreamingName] = value;
    }
  });
  return data;
};

export const sendPageLoadDataToAnalytics = (span: StreamedSpanJSON) => {
  if (span.attributes['sentry.op'] === 'pageload') {
    trackAnalyticsEvent('page_performance_measured', {
      ...span,
      op: span.attributes['sentry.op'],
      origin: stringAttribute(span.attributes, 'sentry.origin'),
      description: span.name,
      timestamp: span.end_timestamp,
      measurements: millisecondMeasurements(span.attributes),
      data: dataWithPreStreamingNames(span.attributes),
    });
  }
  return span;
};
